// removed by extract-text-webpack-plugin
module.exports = {"index":"_3TRSHWkVMhh04X_Z48DA7w","dec":"_1JaWHxyVK_tSSPuytbwR8O","left":"_1TH9nztjkYdnNyBpx1eE07","right":"EX86WGNWxRSZW7MNluj1U","soc":"y_po2fXzpmMy_vVkkdpvr","socLink":"_1sdrLDHHA6Z4iVVgxDeo4P","logoWrapper":"_1GLvCP-sTJ9Jd8iHnqVIR8","logoImg":"_2y4L06QjAeKx-_HTzERn4P","paaStyle":"_3-n7MyJB7buJHjL9xFBL6u","paa":"dAemMhQe4oXeZDFMLo6s_"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/FooterMobile/index.css
// module id = 259
// module chunks = 0